import { OriginStep, PageType, VerticalType } from 'types/common';
import { ApiEndpoint } from 'types/Request/endpoint';

import { ChangedFilterMapping } from '../types';

export const dataMapping: Record<VerticalType, string> = {
    [VerticalType.Hotel]: 'hotelSwitchData',
    [VerticalType.HolidayHome]: 'holidayHomeSwitchData',
    [VerticalType.Cmx]: 'cmxSwitchData',
};

export const verticalShortcutMapping: Record<VerticalType, string> = {
    [VerticalType.Hotel]: 'ho',
    [VerticalType.HolidayHome]: 'fewo',
    [VerticalType.Cmx]: 'cmx',
};

export const trackingMapping: Record<VerticalType, string> = {
    [VerticalType.Hotel]: 'Hotel',
    [VerticalType.HolidayHome]: 'Ferienwohnung',
    [VerticalType.Cmx]: 'Flug + Unterkunft',
};

export const serviceDataEndpointMapping: Record<VerticalType, ApiEndpoint> = {
    [VerticalType.Hotel]: ApiEndpoint.ServiceDataHotel,
    [VerticalType.HolidayHome]: ApiEndpoint.ServiceDataHolidayHome,
    [VerticalType.Cmx]: ApiEndpoint.ServiceDataCmx,
};

export const statsDMapping: Record<VerticalType, string> = {
    [VerticalType.Hotel]: 'hotelhotel.user.toggle',
    [VerticalType.HolidayHome]: 'holidayhome.user.toggle',
    [VerticalType.Cmx]: 'cmx.user.toggle',
};

export const originStepMapping: Record<PageType, string> = {
    [PageType.Home]: OriginStep.Home,
    [PageType.Region]: OriginStep.S2,
    [PageType.Hotel]: OriginStep.S3,
    [PageType.Offer]: OriginStep.S4,
    [PageType.Sem]: OriginStep.Sem,
};

export const changedFilterMapping: ChangedFilterMapping[] = [
    {
        dataKey: 'travellerOrRoom',
        fieldStack: [
            'adult',
            'childrenCount',
            'infants',
            'children_0[age]',
            'children_1[age]',
            'children_2[age]',
            'children_3[age]',
            'roomCount',
        ],
    },
    {
        dataKey: 'travelDate',
        fieldStack: ['departureDate', 'returnDate'],
    },
    {
        dataKey: 'days',
        fieldStack: ['travelDuration'],
    },
];
